import { Connection, PublicKey } from '@solana/web3.js';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { AnchorProvider } from '@project-serum/anchor';
import idl from '../idl.json';

export const wallets = [
  new PhantomWalletAdapter(),
];

export const programId = new PublicKey(idl.metadata.address);

export const tokenId = new PublicKey("ZYDWbrsVbaE83FVXvdHoUVcKRrDN9S2Jskyhsuypump");
export const ownerAddress = 'CpqDPtBYFwVjjBV6GvsAxA8woDcXsUum1Y93ALqCD4sc'

export const getProvider = async (wallet) => {
  const network = "https://mainnet.helius-rpc.com/?api-key=a14c7690-cfe9-4693-95f9-654aed2cd698";
  // const network = "https://api.devnet.solana.com"
  const connection = new Connection(network, 'processed');

  const provider = new AnchorProvider(connection, wallet, 'processed');

  return provider;
}

export const getConnection = async () => {
  const network = "https://mainnet.helius-rpc.com/?api-key=a14c7690-cfe9-4693-95f9-654aed2cd698";
  // const network = "https://api.devnet.solana.com"
  const connection = new Connection(network, 'processed');

  return connection;
}